import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission-group-settings',
  templateUrl: './permission-group-settings.component.html',
  styleUrls: ['./permission-group-settings.component.scss']
})
export class PermissionGroupSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
